module.exports = __webpack_public_path__ + "img/2024-07-01c_8.a96445d7.jpg";